import FileSaver from 'file-saver'
import React, {Component, PropTypes} from 'react'
import Radium from 'radium'

@Radium
export default class DownloadSVG extends Component {
  static propTypes = {
    symbols: PropTypes.array.isRequired,
    transforms: PropTypes.object.isRequired
  }

  escapeRegExp (str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  }

  transformSymbolId (symbolId) {
    const removePrefixes = this.props.transforms.removePrefix.split(/[^a-z0-9-_]/i).filter(prefix => !!prefix)
    const removeSuffixes = this.props.transforms.removeSuffix.split(/[^a-z0-9-_]/i).filter(suffix => !!suffix)
    const addPrefix = this.props.transforms.addPrefix.replace(/[^a-z0-9-_]/gi, '')

    if (removePrefixes.length > 0) {
      const removePrefixesRegExp = new RegExp('^(?:' + removePrefixes.map(this.escapeRegExp).join('|') + '|)(.*)$')
      symbolId = symbolId.replace(removePrefixesRegExp, '$1')
    }

    if (removeSuffixes.length > 0) {
      const removeSuffixesRegExp = new RegExp('^(.*?)(?:' + removeSuffixes.map(this.escapeRegExp).join('|') + '|)$')
      symbolId = symbolId.replace(removeSuffixesRegExp, '$1')
    }

    if (addPrefix) {
      symbolId = addPrefix + symbolId
    }

    return symbolId
  }

  handleOnClick = event => {
    let selectedSymbols = this.props.symbols.filter(symbol => symbol.include)
    let symbolsMarkup = ''
    let fileContent = ''

    selectedSymbols.forEach(symbol => {
      const symbolId = this.transformSymbolId(symbol.id)
      symbolsMarkup += '<symbol id="' + symbolId + '" data-name="' + symbolId + '" viewBox="' + symbol.viewBox + '">' + symbol.content + '</symbol>'
    })

    fileContent += '<?xml version="1.0"?>\n<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="lp-icons" data-name="lp-icons" viewBox="0 0 600 240"><defs>'
    fileContent += symbolsMarkup
    fileContent += '</defs></svg>'

    let file = new File([fileContent], 'lp-icons.svg', {type: 'image/svg+xml;charset=utf-8'}) // eslint-disable-line no-undef
    FileSaver.saveAs(file)
  }

  render () {
    return (
      <button style={styles.base} onClick={this.handleOnClick}>
        <span style={styles.downloadLabel}>Ladda ner</span>
      </button>
    )
  }
}

const styles = {
  base: {
    backgroundColor: '#f9f7f1',
    padding: '1.5em 2em',
    borderLeft: '0',
    borderRight: '0',
    borderTop: '0',
    borderBottom: '5px solid rgba(0, 0, 0, 0.3)',
    borderRadius: '5px',
    color: '#284842',
    cursor: 'pointer',
    fontSize: '1rem',
    width: '100%',
    display: 'block',
    fontWeight: 700,
    ':hover': {
      backgroundColor: '#eae9e3'
    }
  },
  downloadIcon: {
    marginRight: '0.5em',
    verticalAlign: '-0.6em'
  },
  downloadLabel: {
  }
}



// WEBPACK FOOTER //
// src/components/download-svg/index.js